import {mock} from './index';

export default {
  getSecurityRule: () => mock('/admin/security/rule/get'),
  setSecurityRule: () => mock('/admin/security/rule/set'),
  getPasswordRule: () => mock('/security/passwordRule/get')
};
